import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import "./UserForm.css";
import axios from "axios";
import { toast } from "react-toastify";
import { clearSingleCategory } from "../../slices/category/reducer";
import {api} from "../../config";
const CandidateForm = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  console.log("Received token:", token);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifyTokenAndGetQuizId = async () => {
      try {
        if (!token) {
          setError("No token found in URL");
          setLoading(false);
          return;
        }

        // Verify token and get quiz data
        const response = await axios.get(`${api.API_URL}api/quize-access/quize`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        console.log(response)
        if (response.status === 200 && response.data) {
          const quizData = response.data;
          // Store quiz data in localStorage
          localStorage.setItem('selectedQuiz', JSON.stringify({
            id: quizData.quiz.quiz_id,
            token: token,
            quizData: quizData.quiz
          }));
          setLoading(false);
        } else {
          setError("Failed to verify quiz token");
          setLoading(false);
        }
      } catch (error) {
        console.error("Error verifying token:", error);
        setError("Invalid or expired quiz token");
        setLoading(false);
      }
    };

    verifyTokenAndGetQuizId();
  }, [token]);

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
  });

  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
    }

    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required.";
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Enter a valid 10-digit mobile number.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)) {
      newErrors.email = "Enter a valid email address.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      // Get stored quiz data
      const storedQuiz = JSON.parse(localStorage.getItem('selectedQuiz'));
      if (!storedQuiz || !storedQuiz.id) {
        toast.error("Quiz data not found. Please try again.");
        return;
      }

      // Add candidate info to stored quiz data
      const updatedQuizData = {
        ...storedQuiz,
        candidateInfo: formData
      };
      localStorage.setItem('selectedQuiz', JSON.stringify(updatedQuizData));

      navigate("/candidate-form/test-info-page", { state: { formData } });
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      </div>
    );
  }

  return (
    <section className="candidate-section">
      <div className="candidate-container">
        <h2 className="candidate-title">Candidate Information</h2>
        <p className="candidate-subtitle">
          Fill out the form below to get in touch with us.
        </p>

        <form onSubmit={handleSubmit} className="candidate-form">
          <div>
            <label htmlFor="name" className="candidate-label">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="candidate-input"
            />
            {errors.name && <p className="candidate-error text-danger">{errors.name}</p>}
          </div>

          <div>
            <label htmlFor="mobile" className="candidate-label">Phone Number</label>
            <input
              type="tel"
              id="mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleInputChange}
              className="candidate-input"
            />
            {errors.mobile && <p className="candidate-error text-danger">{errors.mobile}</p>}
          </div>

          <div>
            <label htmlFor="email" className="candidate-label">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className="candidate-input"
            />
            {errors.email && <p className="candidate-error text-danger">{errors.email}</p>}
          </div>

          <div className="candidate-button-container">
            <button type="submit" className="candidate-submit-button">
              Submit
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default CandidateForm;
